import { Channel } from '@/Enums/Channel.enum';
import DeviceId from '@/Enums/DeviceId.enum';
import type { IDeviceControlOption } from '@/Interfaces/Device.interface';
import type { LineItemChannel } from '@/types/LineItem/channel.types';

export default class LineItemDeviceService {
  protected static get allDeviceIds(): DeviceId[] {
    return [DeviceId.TV, DeviceId.Mobile, DeviceId.Tablet, DeviceId.Desktop];
  }

  protected static get nonTvDevices() {
    return this.allDeviceIds.filter(id => id !== DeviceId.TV);
  }

  public static get channelDevices(): Record<LineItemChannel, DeviceId[]> {
    return {
      [Channel.CTV]: this.allDeviceIds,
      [Channel.OLV]: this.nonTvDevices,
      [Channel.Display]: this.nonTvDevices,
      [Channel.Audio]: this.allDeviceIds,
    };
  }

  public static filterDevicesByChannel(
    channel: LineItemChannel,
    options: IDeviceControlOption[],
  ): IDeviceControlOption[] {
    const availableDevices = this.channelDevices[channel] ?? [];
    if (!availableDevices.length || !options?.length) {
      return [];
    }
    return options.filter(option => availableDevices.includes(option.value));
  }
}
